import { ReactElement } from 'react';
import styled from 'styled-components';

import { Flex, Section, Typography } from 'components';
import { useProducts } from 'features/products';
import { useModules } from 'features/modules';
import { useSchool } from 'features/school';

const HeaderOverlay = styled(Flex)`
  width: 100%;
  height: 100%;
  background: url('/images/headerOverlay.png');
  position: absolute;
  background-size: cover;
  top: 0;
  left: 0;
`;

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
        ${mediaQueries.mobile} {
          left: -20px;
          top: 1px;

          &::after {
            width: 14px;
            height: 14px;
          }

          &::before {
            top: -40px;
            width: 150px;
            height: 300px;
          }
        }

        ${mediaQueries.tablet} {
          left: -30px;
          top: -2px;

          &::after {
            width: 18px;
            height: 18px;
          }

          &::before {
            top: -40px;
            width: 300px;
            height: 400px;
          }
        }

        ${mediaQueries.desktop} {
          left: -40px;
          top: 0px;

          &::after {
            width: 24px;
            height: 24px;
          }

          &::before {
            top: -60px;
            width: 150px;
            height: 550px;
          }
        }
      `;
  }}
`;

const ProductsHeader = (): ReactElement => {
  const { productDetails } = useProducts();
  const { modules } = useModules();
  const { schoolAlias } = useSchool();

  return productDetails ? (
    <>
      <Flex
        flexGrow={0}
        minHeight={{ m: 240, t: 360, d: 500 }}
        bg={schoolAlias === 'b3' ? 'dark_350' : 'primary_400'}
        backgroundImage={productDetails.product.coverImageUrl ? `url(${productDetails.product.coverImageUrl})` : undefined}
        backgroundSize="cover"
        position="relative"
      >
        <HeaderOverlay alignItems="center">
          <Section position="relative" alignItems="center">
            <Flex position="relative" flexGrow={0} flexDirection="column" maxWidth={{ d: 500 }}>
              <SquareLines />

              <Typography type="type5" fontWeight="bold" color="white" upper>
                {productDetails.product.hat}
              </Typography>

              <Typography as="h1" type="type10" fontWeight="bold" color="white" mt={{ m: '10px', t: 15 }}>
                {productDetails.product.name}
              </Typography>

              <Typography type="type2" color="gray_300" mt={{ m: '10px', t: 15, d: 80 }} lineHeight="1.5">
                <div>{modules?.length ? `${modules.length} módulo${modules.length === 1 ? '' : 's'}` : ''}</div>

                {/* {productDetails?.product.slug !== 'na-rota-do-mercado-financeiro' && modules
                  ? `${modules.reduce((count, module) => {
                      return count + module.contentCount;
                    }, 0)} aulas`
                  : ''}
                    TODO: poder configurar os dados que sao mostrados aqui
                  */}
              </Typography>
            </Flex>
          </Section>
        </HeaderOverlay>
      </Flex>
    </>
  ) : (
    <></>
  );
};
export default ProductsHeader;
